module.exports = __webpack_public_path__ + "img/13.9cdacc49.jpg";